export {View as CardIOView} from 'react-native';
export const CardIOUtilities = {
  preload: function () {
    //do nothing
  },
  CAN_READ_CARD_WITH_CAMERA: false,
};
